import React from "react";
import { Row, Col, Card, Steps } from "antd";
import "./styles.css";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { TEST_RIDE } from "../../../Common/Constants";
import VehicleDetails from "../../VehicleDetails";
import TestRideForm from "./TestRideDetails";
import BeforeRideForm from "./BeforeRideDetails";
import AfterRideForm from "./AfterRideDetails";
import RideNotesForm from "./RideNotes";
const disableRange = 10;
const disableRangeType = "h";
const stepItems = [
  {
    title: TEST_RIDE.TEST_RIDE_DETAILS,
  },
  {
    title: TEST_RIDE.BEFORE_RIDE,
  },
  {
    title: TEST_RIDE.AFTER_RICE,
  },
  {
    title: TEST_RIDE.NOTES,
  },
];

const AddTestRide = ({
  onChangeVehicle,
  vehicle,
  batteryDetails,
}) => {
  const currentStep = useSelector((state) => state.testRide)?.currentStep;

  const timeRangeValidation = (startDate, startTime, endDate, endTime) => {
    const startDateTime = dayjs(startDate)
      .set("hour", startTime.hour())
      .set("minute", startTime.minute())
      .set("second", 0);

    const endDateTime = dayjs(endDate)
      .set("hour", endTime.hour())
      .set("minute", endTime.minute())
      .set("second", 0);

    if (endDateTime > dayjs(startDateTime).add(disableRange, disableRangeType)) {
      return [
        {
          name: "endDate",
          value: endDate,
          errors: [TEST_RIDE.FORM.REQUIRED_FIELDS.MAXIMUM_RANGE_ERROR],
        },
      ];
    } else if (startDateTime < endDateTime) {
      return false
    }else{
      return [
        {
          name: "endDate",
          value: endDate,
          errors: [TEST_RIDE.FORM.REQUIRED_FIELDS.INVALID_DATE_ERROR],
        },
      ]
    }
  }

  return (
    <Row gutter={[16, 16]} className="add-test-ride-page" data-testid="add-test-ride">
      <Col xs={24} sm={24} md={24} lg={24} xl={5}>
        <VehicleDetails
          onChangeImei={onChangeVehicle}
          imei={vehicle}
          cardHeight={"100%"}
          extraDetails={true}
        />
      </Col>
      <Col xs={24} sm={24} md={24} lg={24} xl={19}>
        <Card bordered={false} className="test-ride-form">
          <Row justify={"center"}>
            <Col span={24} lg={{ span: 20 }} xxl={{ span: 16 }}>
              <Steps
                size="large"
                current={currentStep}
                items={stepItems}
                style={{ padding: "10px 0px 20px" }}
              />
            </Col>
          </Row>

          <Row justify={"center"}>
            <Col span={24}>
              {currentStep === 0 ? (
                <TestRideForm batteryDetails={batteryDetails} timeRangeValidation={timeRangeValidation} />
              ) : currentStep === 1 ? (
                <BeforeRideForm timeRangeValidation={timeRangeValidation} />
              ) : currentStep === 2 ? (
                <AfterRideForm timeRangeValidation={timeRangeValidation} />
              ) : (
                <RideNotesForm timeRangeValidation={timeRangeValidation} />
              )}
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default AddTestRide;
